import { render } from "./EventCard.vue?vue&type=template&id=cccfff0e&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=cccfff0e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cccfff0e"

export default script